// {Componente}{Verbo}{Acción}

export const INITIAL_DATA_GET_REQUEST = 'INITIAL_DATA_GET_REQUEST';
export const INITIAL_DATA_GET_SUCCESS = 'INITIAL_DATA_GET_SUCCESS';
export const INITIAL_DATA_GET_ERROR = 'INITIAL_DATA_GET_ERROR';
